export const caseStages = {
	PRELIMINARY_PROCEEDINGS: "PRELIMINARY_PROCEEDINGS",
	PRE_TRIAL_CONFERENCE: "Pre-Trial Conference",
	TRIAL_PROPER: "TRIAL_PROPER",
	JUDGMENT: "JUDGMENT",
	POST_JUDGMENT: "POST_JUDGMENT",
	APPEAL: "APPEAL",
};
